<template>
  <div>
    <iframe width="100%" height="650px"
      src="https://lookerstudio.google.com/embed/u/0/reporting/38b4b905-6e48-44c2-8b6e-ed2a078b6b8d/page/p_2hjhdjv9xd"
      frameborder="0" style="border:0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
}
</script>
